import { initializeApp } from './initialization/AppInitializer';

initializeApp();
